import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef } from "react";
import { Label } from "../Typography/Label.js";
import { toThemeClass } from "../../utils/toThemeClass.js";
import { Stack } from "../Stack/Stack.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toStateClass } from "../../utils/toStateClass.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
const Box = memo(
  forwardRef(
    ({
      actions,
      children,
      className,
      direction = "vertical",
      distinction,
      gap = "small",
      heading,
      intent,
      isActive,
      padding,
      ...divProps
    }, ref) => {
      const componentClassName = `${useClassNamePrefix()}box`;
      return /* @__PURE__ */ jsx(
        "div",
        {
          ...divProps,
          className: classNames(
            componentClassName,
            toStateClass("active", isActive),
            toEnumViewClass(distinction),
            toThemeClass(intent, intent),
            toEnumViewClass(padding),
            className
          ),
          ref,
          children: /* @__PURE__ */ jsxs(Stack, { gap, direction, children: [
            (heading || actions) && /* @__PURE__ */ jsxs("div", { className: `${componentClassName}-header`, children: [
              heading && /* @__PURE__ */ jsx(Label, { children: heading }),
              actions && /* @__PURE__ */ jsx("div", { className: `${componentClassName}-actions`, contentEditable: false, children: actions })
            ] }),
            children
          ] })
        }
      );
    }
  )
);
Box.displayName = "Box";
export {
  Box
};
//# sourceMappingURL=Box.js.map
